












import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import CloudStorageImage from "@/components/CloudStorageImage.vue";

@Component({
    components: {CloudStorageImage}
})
export default class CloudStorageImageCarousel extends Vue {

    @Prop({required: true}) readonly images!: string[];
    @Prop({default: () => "100%"}) readonly maxHeight!: string;

}
